import { useQuery } from '@tanstack/react-query';

// Client
import client from './client';

/**
 * @description send message
 * @param {Object} data {}
 * @returns {Promise<AxiosResponse<any>>}
 */
export const sendContact = (data) => client.post('booking-tunnel/contactUs', data)
  .then((res) => res?.data);

/**
 * @description get howCanHelpTypes
 * @returns {Promise<AxiosResponse<any>>}
 * */
export const getHowCanHelpTypes = () => client.get('booking-tunnel/howCanHelpTypes')
  .then((res) => res?.data?.howCanHelpTypes);

export const useHowCanHelpTypes = (options) => useQuery(
  ['howCanHelpTypes'],
  () => getHowCanHelpTypes(),
  { ...options },
);

/**
 * @description get howCanHelpTypes
 * @returns {Promise<AxiosResponse<any>>}
 * */
export const getResidences = () => client.get('booking-tunnel/residences')
  .then((res) => res?.data?.residences);

export const useResidences = (options) => useQuery(
  ['residences'],
  () => getResidences(),
  { ...options },
);

/**
 * @description get howCanHelpTypes
 * @returns {Promise<AxiosResponse<any>>}
 * */
export const getHourCallBackRanges = () => client.get('booking-tunnel/hourCallBackRanges')
  .then((res) => res?.data?.hourCallBackRanges);

export const useHourCallBackRanges = (options) => useQuery(
  ['hourCallBackRanges'],
  () => getHourCallBackRanges(),
  { ...options },
);
